// Auto-reset countdown timer for Shrine Pro
function initAutoResetCountdown() {
  const countdownWrappers = document.querySelectorAll('.countdown-wrapper');
  
  countdownWrappers.forEach(wrapper => {
    // Function to get end of next day in the correct timezone
    function getEndOfNextDay() {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(23, 59, 59, 999);
      
      // Format for Shopify (YYYY-MM-DDTHH:MM:SS)
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
      const day = String(tomorrow.getDate()).padStart(2, '0');
      const hours = String(tomorrow.getHours()).padStart(2, '0');
      const minutes = String(tomorrow.getMinutes()).padStart(2, '0');
      const seconds = String(tomorrow.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
    
    // Update the data attributes
    function updateCountdownData() {
      const newEndTime = getEndOfNextDay();
      wrapper.setAttribute('data-end-time', newEndTime);
      
      // Trigger the countdown to reinitialize
      const countdownElement = wrapper.querySelector('date-countdown-timer');
      if (countdownElement && countdownElement.init) {
        countdownElement.init();
      }
    }
    
    // Set initial end time to end of next day
    updateCountdownData();
    
    // Check every minute if we need to reset (when timer hits 00:00:00)
    setInterval(() => {
      const countdownElement = wrapper.querySelector('date-countdown-timer');
      if (countdownElement) {
        const timeBlocks = countdownElement.querySelectorAll('.countdown-timer__number');
        let allZero = true;
        
        timeBlocks.forEach(block => {
          const text = block.textContent.trim();
          if (text !== '00' && text !== '0') {
            allZero = false;
          }
        });
        
        // If all time blocks show zero, reset to next day
        if (allZero) {
          setTimeout(updateCountdownData, 1000); // Wait 1 second then reset
        }
      }
    }, 1000);
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initAutoResetCountdown);

// Also initialize when page changes (for SPA-like behavior)
document.addEventListener('shopify:section:load', initAutoResetCountdown);